import { AxiosError } from "axios";
import { ICommit } from "@/apps/merchant3/shared-models/ICommit";
import {
  getManufacturer,
  getOffers,
  getPreRegistrationManufacturer,
  getPreRegistrationDevices,
} from "@/apps/merchant3/services/carts.service";
import {
  IModel,
  IPaymentTerms,
  IPricing,
} from "@/apps/merchant3/models/IStateCart";
import { IOptionDropdown } from "@/types/dropdown";
import {
  IDeviceFamily,
  IDownPaymentRange,
  IRetailPriceRange,
} from "@/apps/merchant3/models/IStateOffers";
import logEvent from "@/apps/merchant3/services/event-logs.service";
import EventLogs from "@/apps/merchant3/types/EventLogs";
import { ICartAccessory } from "@/apps/merchant3/types/CartAccessories";
const actions = {
  /*eslint-disable */
  loadDeviceBrands: (
    { commit }: ICommit,
    payload: { cartTag: string; manufacturer: string }
  ): void => {
    commit("SET_LOADING", true);
    const cartTag = payload.cartTag;
    const manufacturer = payload.manufacturer;
    getOffers(cartTag, manufacturer).then(
      (response) => {
        const { families } = response.data;

        commit("SET_LOADING", false);
        const parsedAllDevices: IDeviceFamily[] = families;
        const parsedDeviceBrands: IOptionDropdown[] = Object.keys(families).map(
          (key) => {
            return {
              name: families[key].friendlyDeviceName,
              code: key,
            };
          }
        );
        commit("LOAD_DEVICE_FAMILIES_DROPDOWN", parsedDeviceBrands);
        commit("LOAD_DEVICE_FAMILIES", parsedAllDevices);
      },
      (error: AxiosError) => {
        commit("SET_LOADING", false);
        commit("SET_OFFER_ERROR_MESSAGE", error.response?.data.message);
        commit("SET_OFFER_ERROR_CODE", error.response?.data.errorCode);
        if (error) console.log("ERROR_SOMETHING_GOES_WRONG");
      }
    );
  },
  loadManufacturer: ({ commit }: ICommit, payload: string): void => {
    commit("SET_LOADING", true);
    getManufacturer(payload).then(
      (response) => {
        const {
          manufacturers,
          recommendedOffers,
          offersWithDiscount,
          selfServiceOffers,
        } = response.data;
        commit("SET_LOADING", false);
        commit("SET_OFFERS_WITH_DISCOUNT", offersWithDiscount);
        const parsedManufacturer: IOptionDropdown[] = Object.keys(
          manufacturers
        ).map((key) => {
          return {
            name: manufacturers[key].name,
            code: manufacturers[key].name.replace(/ /g, ""),
          };
        });

        logEvent(EventLogs.Events.NUMBER_OF_DEVICE_MANUFACTURERS_OFFERED, {
          numberManufacturerLoaded: parsedManufacturer?.length,
        });

        commit("LOAD_MANUFACTURER_DROPDOWN", parsedManufacturer);
        commit("LOAD_MANUFACTURER", manufacturers);
        commit("LOAD_RECOMMENDED_OFFERS", recommendedOffers);
        commit("LOAD_SELF_SERVICE_OFFERS", selfServiceOffers);
        commit("SET_OFFER_ERROR_MESSAGE", null);
        commit("SET_OFFER_ERROR_CODE", null);
      },
      (error: AxiosError) => {
        if (error.response?.data?.errorCode == "10120") {
          logEvent(EventLogs.Events.CUSTOMER_NOT_APPROVED_FOR_OFFERS);
        }

        if (error.response?.data?.errorCode == "10292") {
          logEvent(EventLogs.Events.CUSTOMER_ACTIVE_CREDIT_LINE);
        }

        if (error.response?.data.shouldWaitForCx) {
          logEvent(EventLogs.Events.CUSTOMER_SENT_TO_CX_FROM_OFFERS);
        }
        commit("SET_LOADING", false);
        commit("SET_OFFER_ERROR_MESSAGE", error.response?.data.message);
        commit("SET_OFFER_ERROR_CODE", error.response?.data.errorCode);
        commit("SET_SHOULD_WAIT_FOR_CX", error.response?.data.shouldWaitForCx);
      }
    );
  },
  preRegManufacturers: ({ commit }: ICommit, payload: string): void => {
    getPreRegistrationManufacturer(payload).then(
      (response) => {
        const { manufacturers } = response.data;
        const parsedManufacturer: IOptionDropdown[] = Object.keys(
          manufacturers
        ).map((key) => {
          return {
            name: manufacturers[key].name,
            code: manufacturers[key].name.replace(/ /g, ""),
          };
        });
        parsedManufacturer.unshift({
          name: "All",
          code: "All",
        });
        commit("LOAD_PR_MANUFACTURER_DROPDOWN", parsedManufacturer);
      },
      (error: AxiosError) => {
        commit("SET_OFFER_ERROR_MESSAGE", error.response?.data.message);
        commit("SET_OFFER_ERROR_CODE", error.response?.data.errorCode);
        if (error) console.log("ERROR_SOMETHING_GOES_WRONG");
      }
    );
  },
  preRegDevices: (
    { commit }: ICommit,
    payload: { manufacturer: string; cartTag: string }
  ): void => {
    getPreRegistrationDevices(payload.cartTag, payload.manufacturer).then(
      (response) => {
        const { devices } = response.data;
        commit("LOAD_PR_OFFERS", devices);
      },
      (error: AxiosError) => {
        commit("SET_OFFER_ERROR_MESSAGE", error.response?.data.message);
        commit("SET_OFFER_ERROR_CODE", error.response?.data.errorCode);
        if (error) console.log("ERROR_SOMETHING_GOES_WRONG");
      }
    );
  },
  loadDeviceModels: ({ commit }: ICommit, payload: IOptionDropdown[]): void => {
    commit("LOAD_DEVICE_MODELS_DROPDOWN", payload);
  },

  setSelectedManufacturer: (
    { commit }: ICommit,
    payload: IOptionDropdown
  ): void => {
    commit("SET_SELECTED_MANUFACTURER", payload);
  },

  setSelectedDeviceFamily: (
    { commit }: ICommit,
    payload: IOptionDropdown
  ): void => {
    commit("SET_SELECTED_DEVICE_FAMILY", payload);
  },

  setSelectedDeviceFamilyModels: (
    { commit }: ICommit,
    payload: IModel[]
  ): void => {
    commit("SET_SELECTED_DEVICE_FAMILY_MODELS", payload);
  },

  setSelectedDeviceModel: (
    { commit }: ICommit,
    payload: IOptionDropdown
  ): void => {
    commit("SET_SELECTED_DEVICE_MODEL", payload);
  },

  setSelectedCartAccessory: (
    { commit }: ICommit,
    payload: ICartAccessory
  ): void => {
    commit("SET_SELECTED_CART_ACCESSORY", payload);
  },

  setRetailPriceRange: (
    { commit }: ICommit,
    payload: IRetailPriceRange
  ): void => {
    commit("SET_RETAIL_PRICE_RANGE", payload);
  },

  setDownPaymentRange: (
    { commit }: ICommit,
    payload: IDownPaymentRange
  ): void => {
    commit("SET_DOWN_PAYMENT_RANGE", payload);
  },

  setSelectedDeviceModelObject: (
    { commit }: ICommit,
    payload: IOptionDropdown
  ): void => {
    commit("SET_SELECTED_DEVICE_MODEL_OBJECT", payload);
  },

  setSelectedImageUrl: ({ commit }: ICommit, payload: string): void => {
    commit("SET_SELECTED_IMAGE_URL", payload);
  },

  setPricing: ({ commit }: ICommit, payload: IPricing[]): void => {
    commit("UPDATE_PRICING", payload);
  },

  setSelectedOffer: ({ commit }: ICommit, payload: number): void => {
    commit("SET_SELECTED_OFFER", payload);
  },

  updatePricing: ({ commit }: ICommit, payload: IPaymentTerms): void => {
    commit("UPDATE_PRICING", payload);
  },

  setOfferErrorMessage: ({ commit }: ICommit, payload: string): void => {
    commit("SET_OFFER_ERROR_MESSAGE", payload);
  },
  setShouldWaitForCx: ({ commit }: ICommit, payload: string): void => {
    commit("SET_SHOULD_WAIT_FOR_CX", payload);
  },
  setLoading: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_LOADING", payload);
  },
  resetOffers: ({ commit }: ICommit): void => {
    commit("RESET_OFFERS");
  },
};

export default actions;
